import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Cookies from 'js-cookie';
import { useCallback, useState } from 'react';
import Banner from './Banner';
import PreferencesDialog from './PreferencesDialog';
import saveCustomPreferences from '../utils/saveCustomPreferences';
var ConsentManager = function (_a) {
    var isConsentRequired = _a.isConsentRequired, preferences = _a.preferences, saveConsent = _a.saveConsent, setPreferences = _a.setPreferences;
    var hasPreferences = Cookies.get('tracking-preferences');
    var _b = useState(isConsentRequired && !hasPreferences), bannerVisible = _b[0], setBannerVisible = _b[1];
    var _c = useState(false), preferencesVisible = _c[0], setPreferencesVisible = _c[1];
    var handleHideBanner = useCallback(function () {
        setBannerVisible(false);
    }, []);
    var handleShowPreferences = useCallback(function () {
        setPreferencesVisible(true);
    }, []);
    var handleHidePreferences = useCallback(function () {
        setPreferencesVisible(false);
    }, []);
    var handleSave = useCallback(function (newPreferences) {
        setPreferences(newPreferences);
        saveConsent();
        handleHidePreferences();
        handleHideBanner();
    }, [handleHideBanner, handleHidePreferences, saveConsent, setPreferences]);
    var handleAcceptAllClick = useCallback(function () {
        handleSave(saveCustomPreferences(true));
    }, [handleSave]);
    return (_jsxs(_Fragment, { children: [_jsx(Banner, { onAcceptAllClick: handleAcceptAllClick, onManageCookiesClick: handleShowPreferences, visible: bannerVisible }), _jsx(PreferencesDialog, { handleSave: handleSave, onClose: handleHidePreferences, preferences: preferences, visible: preferencesVisible })] }));
};
export default ConsentManager;
